import { getCookie, getJSONCookie, setCookie, deleteCookie } from '~/store/storage'

class UserCookie {
  constructor() {
    this._accessToken = getCookie('access_token')
    this._address = getJSONCookie('address')
    this._createdAt = getCookie('created_at')
    this._email = getCookie('email')
    this._expireTime = Number(getCookie('expire_time'))
    this._geoLocation = getJSONCookie('geo_location')
    this._refreshToken = getCookie('refresh_token')
    this._serviceRegionId = getCookie('service_region_id')
    this._serviceType = getCookie('service_type')
    this._tokenType = getCookie('token_type')
  }

  get accessToken() {
    return this._accessToken
  }
  set accessToken(accessToken) {
    this._accessToken = accessToken
    setCookie({ access_token: accessToken })
  }

  get address() {
    return this._address
  }
  set address(address) {
    this._address = address
    setCookie({ address })
  }

  get createdAt() {
    return this._createdAt
  }
  set createdAt(createdAt) {
    this._createdAt = createdAt
    setCookie({ created_at: createdAt })
  }

  get email() {
    return this._email
  }
  set email(email) {
    this._email = email
    setCookie({ email })
  }

  /**
   * epoc time that the accessToken expires
   * @type Number
   */
  get expireTime() {
    return this._expireTime
  }
  set expireTime(expireTime) {
    this._expireTime = expireTime
    setCookie({ expire_time: expireTime })
  }

  get geoLocation() {
    return this._geoLocation
  }
  set geoLocation(geoLocation) {
    this._geoLocation = geoLocation
    setCookie({ geo_location: geoLocation })
  }

  get refreshToken() {
    return this._refreshToken
  }
  set refreshToken(refreshToken) {
    this._refreshToken = refreshToken
    setCookie({ refresh_token: refreshToken })
  }

  get serviceRegionId() {
    return this._serviceRegionId
  }
  set serviceRegionId(serviceRegionId) {
    this._serviceRegionId = serviceRegionId
    setCookie({ service_region_id: serviceRegionId })
  }

  get serviceType() {
    return this._serviceType
  }
  set serviceType(serviceType) {
    this._serviceType = serviceType
    setCookie({ service_type: serviceType })
  }

  get tokenType() {
    return this._tokenType
  }
  set tokenType(tokenType) {
    this._tokenType = tokenType
    setCookie({ token_type: tokenType })
  }

  // Derived properties

  get addressId() {
    return this._address?.id
  }

  get isLoggedIn() {
    return Boolean(this._accessToken && this._tokenType)
  }

  logout() {
    this._accessToken = null
    this._address = null
    this._createdAt = null
    this._email = null
    this._expireTime = null
    this._geoLocation = null
    this._refreshToken = null
    this._serviceRegionId = null
    this._serviceType = null
    this._tokenType = null
    deleteCookie('access_token')
    deleteCookie('address')
    deleteCookie('created_at')
    deleteCookie('email')
    deleteCookie('expire_time')
    deleteCookie('geo_location')
    deleteCookie('refresh_token')
    deleteCookie('service_region_id')
    deleteCookie('service_type')
    deleteCookie('token_type')
  }
}

/**
 * userCookie is a singleton of UserCookie, which is a plain JS class
 * for manipulating cookies related to the user.
 * It is not reactive. It should be avoided in react components.
 */
const userCookie = new UserCookie()

export { userCookie }
